/* DATE FUNCTIONS */

/* For ex: dateString = 2024-04-01T08:30:00Z (ISO 8601)
    return value = 1 April, 2024 8:30 UTC 
    verified on https://www.timestamp-converter.com/
*/

export const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getUTCDate();
    const month = date.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
    const year = date.getUTCFullYear();

    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, '0'); // ensures two digits for minutes

    return `${day} ${month}, ${year} ${hours}:${minutes} UTC`;
}

// 1724340540 
export const epochDate = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert timestamp to milliseconds
    return date.toUTCString().replace('GMT', 'UTC').slice(0, -3); // Format and remove 'GMT'
};

// input: 1724340540
// output: 2024-04-01T08:30:00Z

export const getTimeEpochToUTC = (time) => {
    const date = new Date(time * 1000); // Convert seconds to milliseconds
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

// For ex:
// input: 2025-02-06T06:54:40.193Z
// putput: 2025-02-06T06:54:40Z
export const getTimeUTCWithNoMs = (time) => {
    const date = new Date(time); // Convert milliseconds to Date object
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

/* CONVERSION FUNCTIONS */

// list: constant having keys label and value
// search: 'term needs to be searched'

// this function returns the server value for the label displayed on UI
export const getValue = (list, search) => {
    const item = list.find(item => item.label === search);
    return item ? item.value : null;
}

// this function returns the label for the label server value
export const getLabel = (list, search) => {
    const item = list.find(item => item.value === search);
    return item ? item.label : null;
}

export const calculateTimePercentage = (startTime, endTime, currentTime) => {
    const totalDuration = endTime - startTime;
    const elapsedTime = currentTime - startTime;
    const percentage = Math.floor((elapsedTime / totalDuration) * 100);
    // Ensure the percentage is between 0 and 100
    return Math.min(Math.max(percentage, 0), 100);
};

export const calculateProgressTime = (startTime, currentTime) => {
    const progressMilliseconds = currentTime - startTime;
    const progressSeconds = Math.floor(progressMilliseconds);
    const hours = Math.floor(progressSeconds / 3600);
    const minutes = Math.floor((progressSeconds % 3600) / 60);
    const seconds = progressSeconds % 60;

    const formatNumber = (num) => num.toString().padStart(2, '0');

    return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`;
};